<div class="mentor-profile-container">
  @if (isLoading) {
  <div class="loading-container">
    <p>Cargando perfil del usuario...</p>
  </div>
  } @else if (user) {
  <div class="mentor-content">
    <!-- Encabezado y navegación -->
    <div class="header">
      <div class="back-link" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>{{ user.name }}</span>
      </div>
    </div>

    <div class="content_container">
      <!-- Sección de semana actual -->
      <div class="week_indicator_container">
        <div class="week_indicator">
          {{ user.name }} se encuentra en la semana número {{ getCurrentWeek() }} del programa Phoenix Executive
        </div>
      </div>
      
      <div class="user_info_container">
        <div class="profile_section">
          <div class="profile_image_container">
            <img [src]="getProfilePhotoUrl()" alt="Foto de perfil" class="profile_image" />
          </div>
          <div class="profile_info">
            <h2 class="user_name">{{ user.name }} {{ user.lastName }}</h2>
            <p class="user_title">{{ getUserTitle() }}</p>
            <div class="status_badge">
              <span class="status_text">{{ getUserStatus() }}</span>
            </div>
          </div>
        </div>
        
        <div class="divider"></div>
        
        <div class="contact_section">
          <div class="contact_item">
            <mat-icon class="contact_icon">email</mat-icon>
            <span class="contact_text">{{ user.email || 'No disponible' }}</span>
          </div>
          <div class="contact_item">
            <mat-icon class="contact_icon">phone</mat-icon>
            <span class="contact_text">{{ user.phone || 'No disponible' }}</span>
          </div>
          <div class="contact_item">
            <mat-icon class="contact_icon">location_on</mat-icon>
            <span class="contact_text">{{ getUserLocation() }}</span>
          </div>
          <div class="contact_item">
            <mat-icon class="contact_icon">linkedin</mat-icon>
            <span class="contact_text">{{ getLinkedInUrl() }}</span>
          </div>
        </div>
      </div>

      <!-- Sección de progreso -->
   

      <div class="progress-steps-section">
        <div class="progress-section">
          <h2 class="progress-title">Progreso</h2>
          <p class="progress-subtitle">Mira el progreso de {{ user.name }} aquí</p>
        </div>
        <div class="progress-steps-wrapper">
          <div class="progress-steps">
            <div class="step" 
                 *ngFor="let step of progressSteps; let i = index" 
                 [class.completed]="step.status === 'completed'"
                 [class.in-progress]="step.status === 'in-progress'"
                 [class.pending]="step.status === 'pending'">
              
              <div class="step-content">
                <div class="step-circle">
                  <span class="step-number">{{ step.number }}</span>
                </div>
                
                <!-- Línea conectora independiente a la derecha (excepto para el último step) -->
                <div class="step-connector" *ngIf="i < progressSteps.length - 1"></div>
              </div>
              
              <div class="step-info">
                <h3 class="step-title">{{ step.title }}</h3>
                <div class="step-status">
                  <span class="status-text">{{ step.statusText }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cards de tareas y agenda -->
      <div class="cards-section">
        <!-- Card de activación de tareas -->
        <div class="task-activation-card">
          <div class="card-header">
            <h3 class="card-title">Activa tus tareas aqui</h3>
            <p class="card-subtitle">Activa y desactiva las tareas de tus mentoreados aqui</p>
          </div>
          <div class="tasks-list">
            <div class="task-item" *ngFor="let task of taskList; let i = index">
              <div class="task-badge">
                <span class="task-number">{{ i + 1 }}</span>
              </div>
              <div class="task-info">
                <h4 class="task-name">{{ task.name }}</h4>
                <p class="task-description">Activa o desactiva las tareas aqui</p>
              </div>
              <div class="task-toggle">
                <label class="toggle-switch">
                  <input type="checkbox" [(ngModel)]="task.active" (change)="onTaskToggle(task, $event)">
                  <span class="toggle-slider">
                    <span class="toggle-icon" [class.active]="task.active">
                      <span *ngIf="task.active">✓</span>
                      <span *ngIf="!task.active">−</span>
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Card de agenda -->
        <div class="agenda-card">
          <div class="card-header">
            <h3 class="card-title">Agenda</h3>
            <p class="card-subtitle">Revisa aquí tus próximas sesiones</p>
          </div>
          
          <!-- Lista de Citas Programadas (diseño igual a dashboard-executive) -->
          <div class="eventos-lista">
            <div class="eventos-content">
              <!-- Debug info -->
              <div *ngIf="agendaAppointments.length === 0" class="no-events">
                No hay citas programadas
              </div>
              <div class="eventos-dia" *ngFor="let dayEvents of agendaAppointments">
                <div class="dia-header">
                  <span class="dia-nombre">{{ dayEvents.dayName }}, {{ dayEvents.date }}</span>
                  <button class="dia-menu-btn" (click)="toggleDayMenu(dayEvents.date)">
                    <span>⋮</span>
                  </button>
                </div>
                
                <div class="eventos-del-dia">
                  <div class="evento-item" *ngFor="let event of dayEvents.events">
                    <div class="evento-hora">{{ event.time }}</div>
                    <div class="evento-linea" [class]="getEventLineClass(event.type)"></div>
                    <div class="evento-info">
                      <div class="evento-tipo">{{ event.type }}</div>
                      <div class="evento-titulo">{{ event.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- <div class="user_details_container">
        <h2>Detalles de usuario:</h2>
        <p>{{ user.name }} se encuentra en la <strong>Prueba de Autoconocimiento - Etapa: Descúbrete</strong></p>

        <div class="detail-item">
          <span class="label">Próxima cita:</span>
          @if (proximaCita) {
          <span class="value">{{ proximaCita | date: 'd \'de\' MMMM \'del\' y':'':'es-PE' }}</span>
          }
        </div>

        <div class="detail-item">
          <span class="label">Última actividad:</span>
          <span class="value">{{user.lastAccess?.date | date: 'd \'de\' MMMM \'del\' y':'':'es-PE' }}</span>
        </div>
      </div> -->
    </div>

     <!-- Tabla de citas realizadas -->
     <div class="appointments-history-section">
      <div class="section-header">
        <div class="header-content">
          <div class="title-section">
            <h3 class="section-title">Historial y próximas reuniones con {{ user?.name || 'Alejandra' }}</h3>
            <p class="section-subtitle">Revisa aquí el próximas reuniones ademas del historial y notas de las sesiones con {{ user?.name || 'Alejandra' }}.</p>
          </div>
          <button class="view-complete-list-btn" (click)="openAppointmentsModal()">Ver lista completa</button>
        </div>
      </div>
      
      <div class="appointments-table-container">
        <div class="table-responsive" *ngIf="allAppointments.length > 0">
          <table class="appointments-table">
            <thead>
              <tr>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Hora</th>
                <th>Duración</th>
                <th>Notas</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let appointment of allAppointments">
                <td class="status-cell">
                  <span class="status-text" [class.pending]="!isSessionInPast(appointment)" [class.completed]="isSessionInPast(appointment)">
                    {{ isSessionInPast(appointment) ? 'Realizada' : 'Pendiente' }}
                  </span>
                </td>
                <td class="appointment-date">
                  {{ appointment.date | date: 'dd/MM/yyyy' }}
                </td>
                <td class="appointment-time">
                  {{ appointment.time | timeFormat }}
                </td>
                <td class="appointment-duration">
                  {{ appointment.duration || 60 }} minutos
                </td>
                <td class="appointment-notes">
                  <button class="notes-button" (click)="viewAppointmentNotes(appointment)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                </td>
                <td class="appointment-actions">
                  <button class="action-button"
                          [class.pending-btn]="!isSessionInPast(appointment)"
                          [class.disabled-btn]="isSessionInPast(appointment)"
                          [disabled]="isSessionInPast(appointment)"
                          (click)="enterSession(appointment)">
                    {{ isSessionInPast(appointment) ? 'Sesión pasada' : 'Ingresar a sesión' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="no-appointments" *ngIf="allAppointments.length === 0">
          <div class="empty-state">
            <i class="fas fa-calendar-times"></i>
            <h4>No hay citas programadas</h4>
            <p>No se han programado sesiones con este usuario aún.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección de Entregables -->
    <div class="deliverables-section">
      <div class="section-header">
        <div class="header-content">
          <div class="title-section">
            <h3 class="section-title">Entregables</h3>
            <p class="section-subtitle">Revisa los entregables de {{ user?.name || 'Alejandra' }} aquí</p>
          </div>
        </div>
      </div>

      <div class="deliverables-list-container">
        <div class="deliverable-item" (click)="openCircleLifeModal()" style="cursor: pointer;">
          <div class="deliverable-number">1</div>
          <div class="deliverable-title">Círculo de la vida</div>
          <div class="deliverable-status" [ngClass]="getCirculoVidaStatus().statusClass">
            <i [class]="getCirculoVidaStatus().icon"></i> {{ getCirculoVidaStatus().text }}
          </div>
        </div>
        <div class="deliverable-item" (click)="openAnalisisProfundoModal()" style="cursor: pointer;">
          <div class="deliverable-number">2</div>
          <div class="deliverable-title">Análisis profundo</div>
          <div class="deliverable-status" [ngClass]="getAnalisisProfundoStatus().statusClass">
            <i [class]="getAnalisisProfundoStatus().icon"></i> {{ getAnalisisProfundoStatus().text }}
          </div>
        </div>
        <div class="deliverable-item" (click)="openIdentityMapModal()" style="cursor: pointer;">
          <div class="deliverable-number">3</div>
          <div class="deliverable-title">Guia de Reflexión Personal</div>
          <div class="deliverable-status" [ngClass]="getIdentityMapStatus().statusClass">
            <i [class]="getIdentityMapStatus().icon"></i> {{ getIdentityMapStatus().text }}
          </div>
        </div>
        <div class="deliverable-item" (click)="openIdentityMapDetailsModal()" style="cursor: pointer;">
          <div class="deliverable-number">4</div>
          <div class="deliverable-title">Mapa de Identidad</div>
          <div class="deliverable-status" [ngClass]="getIdentityMapDetailsStatus().statusClass">
            <i [class]="getIdentityMapDetailsStatus().icon"></i> {{ getIdentityMapDetailsStatus().text }}
          </div>
        </div>
        <div class="deliverable-item" (click)="openVisionboardModal()" style="cursor: pointer;">
          <div class="deliverable-number">5</div>
          <div class="deliverable-title">Visionboard</div>
          <div class="deliverable-status" [ngClass]="getVisionboardStatus().statusClass">
            <i [class]="getVisionboardStatus().icon"></i> {{ getVisionboardStatus().text }}
          </div>
        </div>
        <div class="deliverable-item" (click)="openPRDModal()" style="cursor: pointer;">
          <div class="deliverable-number">6</div>
          <div class="deliverable-title">PRD</div>
          <div class="deliverable-status" [ngClass]="getPRDStatus().statusClass">
            <i [class]="getPRDStatus().icon"></i> {{ getPRDStatus().text }}
          </div>
        </div>
      </div>
    </div>
    
    <!-- Tabla preliminar de objetivos -->
    <div class="objectives-preview-card">
      <div class="preview-header">
        <div class="header-text">
          <h2>Objetivos recientes</h2>
          <p class="preview-subtitle">Últimos 5 objetivos registrados para el mentoreado.</p>
        </div>
        <button class="view-complete-list-btn" (click)="onVerTodosObjetivos()">
          Ver todos
        </button>
      </div>

      <table class="preview-table" *ngIf="objetivosPreview && objetivosPreview.length > 0; else noObjetivos">
        <thead>
          <tr>
            <th>Objetivo</th>
            <th>Dimensión</th>
            <th>Fecha fin</th>
            <th>Avance</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let objetivo of objetivosPreview">
            <tr class="objective-row">
              <td class="name-cell">
                <button
                  type="button"
                  class="expand-btn"
                  [class.is-expanded]="isObjectiveExpanded(objetivo)"
                  (click)="toggleObjective(objetivo, $event)"
                  aria-label="Mostrar actividades"
                  [attr.aria-expanded]="isObjectiveExpanded(objetivo)"
                >
                  <mat-icon>
                    {{ isObjectiveExpanded(objetivo) ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                </button>
                <div class="objective-info">
                  <span class="objective-name">{{ objetivo.nombre }}</span>
                  <span class="objective-id" *ngIf="objetivo._id">ID: {{ objetivo._id }}</span>
                </div>
              </td>
              <td>
                <span class="dimension-badge">{{ objetivo.dimension }}</span>
              </td>
              <td class="date-cell">{{ objetivo.inicio }}</td>
              <td class="date-cell">{{ objetivo.fin }}</td>
              <td>
                <div class="progress-pill" [class.complete]="objetivo.porcentaje === 100">
                  {{ objetivo.porcentaje }}%
                </div>
              </td>
              <td>
                <span class="status-badge" [ngClass]="getObjectiveStatusClass(objetivo.state)">
                  {{ formatObjectiveState(objetivo.state) }}
                </span>
              </td>
            </tr>
            <tr *ngIf="isObjectiveExpanded(objetivo)" class="activities-row">
              <td colspan="5">
                <div class="activities-wrapper">
                  <h3>Actividades</h3>
                  <table class="activities-table">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        <th>Inicio</th>
                        <th>Fin</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="getActivitiesPreview(objetivo) as actividades">
                        <tr *ngFor="let actividad of actividades">
                          <td>{{ actividad.nombre }}</td>
                          <td class="activity-desc">{{ actividad.descripcion }}</td>
                          <td class="date-cell">{{ actividad.inicio }}</td>
                          <td class="date-cell">{{ actividad.fin }}</td>
                          <td>
                            <span class="activity-status" [ngClass]="getActivityStatusClass(actividad.estado)">
                              {{ actividad.estado }}
                            </span>
                          </td>
                        </tr>
                        <tr *ngIf="actividades.length === 0">
                          <td colspan="5" class="no-activities">
                            No hay actividades registradas para este objetivo.
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <ng-template #noObjetivos>
        <div class="no-objectives">
          <p>Este mentoreado aún no tiene objetivos registrados.</p>
        </div>
      </ng-template>
    </div>

<!-- Modal de objetivos completos -->
<div class="modal-overlay" *ngIf="showObjectivesModal" (click)="closeObjectivesModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Objetivos de {{ user?.name || 'Alejandra' }}</h3>
      <p class="modal-subtitle">
        Revisa la lista completa de objetivos registrados y su estado de avance.
      </p>
      <button class="close-modal-btn" (click)="closeObjectivesModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-filters">
      <div class="filter-group">
        <label for="objective-status-filter">Filtrar estado</label>
        <select
          id="objective-status-filter"
          [(ngModel)]="objectiveStatusFilter"
          (change)="applyObjectiveFilters()"
        >
          <option value="">Todos</option>
          <option value="Pendiente">Pendiente</option>
          <option value="En progreso">En progreso</option>
          <option value="Completado">Completado</option>
        </select>
      </div>

      <div class="filter-group">
        <label for="objective-dimension-filter">Filtrar dimensión</label>
        <select
          id="objective-dimension-filter"
          [(ngModel)]="objectiveDimensionFilter"
          (change)="applyObjectiveFilters()"
        >
          <option value="">Todas</option>
          <option *ngFor="let dimension of objectiveDimensionOptions" [value]="dimension">
            {{ dimension }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <app-custom-date-picker
          [(ngModel)]="objectiveDateFromFilter"
          (dateChange)="applyObjectiveFilters()"
          placeholder="Desde (inicio)"
        ></app-custom-date-picker>
      </div>

      <div class="filter-group">
        <app-custom-date-picker
          [(ngModel)]="objectiveDateToFilter"
          (dateChange)="applyObjectiveFilters()"
          placeholder="Hasta (fin)"
        ></app-custom-date-picker>
      </div>
    </div>

    <div class="modal-content">
      <div class="objectives-modal">
        <table class="preview-table modal-objectives-table" *ngIf="filteredObjectives.length > 0; else noObjectivesModal">
          <thead>
            <tr>
              <th>Objetivo</th>
              <th>Dimensión</th>
              <th>Fecha inicio</th>
              <th>Fecha fin</th>
              <th>Avance</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let objetivo of paginatedObjectives">
              <tr class="objective-row">
                <td class="name-cell">
                  <button
                    type="button"
                    class="expand-btn"
                    [class.is-expanded]="isObjectiveExpanded(objetivo)"
                    (click)="toggleObjective(objetivo, $event)"
                    aria-label="Mostrar actividades"
                    [attr.aria-expanded]="isObjectiveExpanded(objetivo)"
                  >
                    <mat-icon>
                      {{ isObjectiveExpanded(objetivo) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </button>
                  <div class="objective-info">
                    <span class="objective-name">{{ objetivo.nombre }}</span>
                    <span class="objective-id" *ngIf="objetivo._id">ID: {{ objetivo._id }}</span>
                  </div>
                </td>
                <td>
                  <span class="dimension-badge">{{ objetivo.dimension }}</span>
                </td>
                <td class="date-cell">{{ objetivo.inicio }}</td>
                <td class="date-cell">{{ objetivo.fin }}</td>
                <td>
                  <div class="progress-pill" [class.complete]="objetivo.porcentaje === 100">
                    {{ objetivo.porcentaje }}%
                  </div>
                </td>
                <td>
                  <span class="status-badge" [ngClass]="getObjectiveStatusClass(objetivo.state)">
                    {{ formatObjectiveState(objetivo.state) }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="isObjectiveExpanded(objetivo)" class="activities-row">
                <td colspan="6">
                  <div class="activities-wrapper">
                    <h3>Actividades</h3>
                    <table class="activities-table">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Descripción</th>
                          <th>Inicio</th>
                          <th>Fin</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="getActivitiesPreview(objetivo, 10) as actividades">
                          <tr *ngFor="let actividad of actividades">
                            <td>{{ actividad.nombre }}</td>
                            <td class="activity-desc">{{ actividad.descripcion }}</td>
                            <td class="date-cell">{{ actividad.inicio }}</td>
                            <td class="date-cell">{{ actividad.fin }}</td>
                            <td>
                              <span class="activity-status" [ngClass]="getActivityStatusClass(actividad.estado)">
                                {{ actividad.estado }}
                              </span>
                            </td>
                          </tr>
                          <tr *ngIf="actividades.length === 0">
                            <td colspan="5" class="no-activities">
                              No hay actividades registradas para este objetivo.
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <ng-template #noObjectivesModal>
          <div class="no-objectives">
            <p>No se encontraron objetivos con los filtros aplicados.</p>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="modal-footer" *ngIf="filteredObjectives.length > 0">
      <div class="pagination-info">
        <span>
          Mostrando {{ getObjectivesStartIndex() }} de {{ filteredObjectives.length }} resultados
        </span>
      </div>

      <div class="pagination-controls">
        <button
          class="pagination-btn"
          [disabled]="objectiveCurrentPage === 1"
          (click)="goToObjectivesPage(objectiveCurrentPage - 1)"
        >
          <i class="fas fa-chevron-left"></i>
        </button>

        <div class="pagination-pages">
          <button
            *ngFor="let page of getObjectivesVisiblePages()"
            class="page-btn"
            [class.active]="page === objectiveCurrentPage"
            (click)="goToObjectivesPageIfNumber(page)"
            [disabled]="page === '...'"
          >
            {{ page }}
          </button>
        </div>

        <button
          class="pagination-btn"
          [disabled]="objectiveCurrentPage === getObjectivesTotalPages()"
          (click)="goToObjectivesPage(objectiveCurrentPage + 1)"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>

      <div class="items-per-page">
        <label for="objective-items-per-page">Mostrar</label>
        <select
          id="objective-items-per-page"
          [(ngModel)]="objectivesItemsPerPage"
          (change)="onObjectivesItemsPerPageChange()"
        >
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
        </select>
      </div>
    </div>
  </div>
</div>

    <!-- Componente Permisos -->
    <!-- <app-users-assigned-permissions [user]="user"></app-users-assigned-permissions> -->

    <!-- Sección de resumen de citas -->
<!-- 
    <div class="appointments-summary-container">
      <div class="calendar-container">
        <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateChange($event)"></mat-calendar>
      </div>

      <div class="appointment-item-container">
        <div class="appointment-item">
          <h3 class="appointment-title">Próxima cita</h3>
          @if (citasFechaSeleccionada.length > 0 && citaproxima[0]) {
          <p class="appointment-info">
            Tienes una próxima cita con {{ citaproxima[0]?.clientName }}:<br>
            ({{ citaproxima[0]?.date | date: 'fullDate':'':'es-PE' }})
          </p>
          <p class="appointment-time">Empieza a las {{ citaproxima[0]?.time | timeFormat}}</p>
          <div class="appointment-actions">
            <button class="btn-start" (click)="iniciarReunionGoogleMeet()">Empezar cita</button>
            <button class="btn-summary">Generar resumen de cita</button>
          </div>
          }
          @else {
          <p class="appointment-info">
            No tienes citas programadas para la fecha seleccionada.
          </p>
          }
        </div>
      </div>


    </div> -->



  </div>
  } @else {
  <div class="loading-container">
    <p>No se encontró el usuario</p>
  </div>
  }
</div>

<!-- Modal para lista completa de citas -->
<div class="modal-overlay" *ngIf="showAppointmentsModal" (click)="closeAppointmentsModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Historial y próximas reuniones con {{ user?.name || 'Alejandra' }}</h3>
      <p class="modal-subtitle">Revisa aquí el próximas reuniones ademas del historial y notas de las sesiones con {{ user?.name || 'Alejandra' }}.</p>
      <button class="close-modal-btn" (click)="closeAppointmentsModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-filters">
      <div class="filter-group filter-group-full-width">
        <label for="status-filter">Filtrar estado</label>
        <select id="status-filter" [(ngModel)]="statusFilter" (change)="filterAppointments()">
          <option value="">Todos</option>
          <option value="Pendiente">Pendiente</option>
          <option value="Realizada">Realizada</option>
        </select>
      </div>
      
      <div class="filter-group">
        <app-custom-date-picker
          [(ngModel)]="dateFromFilter" 
          (dateChange)="filterAppointments()"
          placeholder="Filtrar citas desde">
        </app-custom-date-picker>
      </div>
      
      <div class="filter-group">
        <app-custom-date-picker
          [(ngModel)]="dateToFilter" 
          (dateChange)="filterAppointments()"
          placeholder="Filtrar citas hasta">
        </app-custom-date-picker>
      </div>
    </div>
    
    <div class="modal-content">
      <div class="appointments-table-container">
        <div class="table-responsive" *ngIf="filteredAppointments.length > 0">
          <table class="appointments-table">
            <thead>
              <tr>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Hora</th>
                <th>Duración</th>
                <th>Notas</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let appointment of paginatedAppointments">
                <td class="status-cell">
                  <span class="status-text" [class.pending]="!isSessionInPast(appointment)" [class.completed]="isSessionInPast(appointment)">
                    {{ isSessionInPast(appointment) ? 'Realizada' : 'Pendiente' }}
                  </span>
                </td>
                <td class="appointment-date">
                  {{ appointment.date | date: 'dd/MM/yyyy' }}
                </td>
                <td class="appointment-time">
                  {{ appointment.time | timeFormat }}
                </td>
                <td class="appointment-duration">
                  {{ appointment.duration }} minutos
                </td>
                <td class="appointment-notes">
                  <button class="notes-button" (click)="viewAppointmentNotes(appointment)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                </td>
                <td class="appointment-actions">
                  <button class="action-button"
                          [class.pending-btn]="!isSessionInPast(appointment)"
                          [class.disabled-btn]="isSessionInPast(appointment)"
                          [disabled]="isSessionInPast(appointment)"
                          (click)="enterSession(appointment)">
                    {{ isSessionInPast(appointment) ? 'Sesión pasada' : 'Ingresar a sesión' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="no-appointments" *ngIf="filteredAppointments.length === 0">
          <div class="empty-state">
            <i class="fas fa-calendar-times"></i>
            <h4>No hay citas encontradas</h4>
            <p>No se encontraron citas con los filtros aplicados.</p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal-footer" *ngIf="filteredAppointments.length > 0">
      <div class="pagination-info">
        <span>Mostrando {{ getStartIndex() }} de {{ filteredAppointments.length }} resultados</span>
      </div>
      
      <div class="pagination-controls">
        <button class="pagination-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <i class="fas fa-chevron-left"></i>
        </button>
        
        <div class="pagination-pages">
          <button *ngFor="let page of getVisiblePages()" 
                  class="page-btn" 
                  [class.active]="page === currentPage"
                  (click)="goToPageIfNumber(page)"
                  [disabled]="page === '...'">
            {{ page }}
          </button>
        </div>
        
        <button class="pagination-btn" [disabled]="currentPage === getTotalPages()" (click)="goToPage(currentPage + 1)">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      
      <div class="items-per-page">
        <label for="items-per-page">Mostrar</label>
        <select id="items-per-page" [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!-- Modal para notas de citas -->
<div class="modal-overlay" *ngIf="showNotesModal" (click)="closeNotesModal()">
  <div class="modal-container notes-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Notas de la sesión</h3>
      <p class="modal-subtitle">Registra observaciones y adjunta documentos para la sesión del {{ selectedAppointment?.date | date: 'dd/MM/yyyy' }} a las {{ selectedAppointment?.time | timeFormat }}</p>
      <button class="close-modal-btn" (click)="closeNotesModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-content notes-content">
      <!-- Editor de texto enriquecido -->
      <div class="notes-editor-section">
        <!-- Toolbar personalizado para funcionalidades adicionales -->
        <div class="custom-toolbar">
          <div class="toolbar-group">
            <button class="toolbar-btn" (click)="togglePreview()" [class.active]="showPreview">
              <i class="fas fa-eye"></i>
              Vista previa
            </button>
            <button class="toolbar-btn" (click)="clearQuillEditor()">
              <i class="fas fa-eraser"></i>
              Limpiar
            </button>
          </div>
        </div>
        
        <div class="editor-content">
          <!-- Editor Quill -->
          <div 
            #quillEditor
            class="quill-editor"
            [style.display]="showPreview ? 'none' : 'block'">
            <div *ngIf="!quillInstance" class="quill-loading">
            </div>
          </div>
          
          <!-- Vista previa -->
          <div 
            *ngIf="showPreview" 
            class="preview-content"
            [innerHTML]="appointmentNotes">
          </div>
        </div>
      </div>
      
      <!-- Sección de carga de archivos -->
      <div class="file-upload-section">
        <div class="file-upload-header">
          <h4 class="file-upload-title">Cargar archivos</h4>
          <button class="upload-file-btn" (click)="triggerFileUpload()">
            <i class="fas fa-cloud-upload-alt"></i>
            Subir archivo
          </button>
        </div>
        
        <input 
          type="file" 
          #fileInput 
          id="fileInput"
          (change)="onFileSelected($event)" 
          multiple 
          accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png"
          style="display: none;">
        
        <div class="files-list" *ngIf="appointmentFiles.length > 0">
          <div class="files-table">
            <div class="files-header">
              <div class="file-name-header">Nombre del archivo</div>
              <div class="file-date-header">Fecha</div>
              <div class="file-actions-header">Acciones</div>
            </div>
            
            <div class="files-body">
              <div class="file-item" *ngFor="let file of appointmentFiles; let i = index">
                <div class="file-name">
                  <i class="fas fa-file" [class]="getFileIconClass(file.name)"></i>
                  {{ file.name }}
                </div>
                <div class="file-date">{{ file.uploadDate | date: 'dd/MM/yyyy' }}</div>
                <div class="file-actions">
                  <button class="action-btn view-btn" (click)="viewFile(file)" title="Ver archivo">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button class="action-btn delete-btn" (click)="deleteFile(i)" title="Eliminar archivo">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="no-files" *ngIf="appointmentFiles.length === 0">
          <i class="fas fa-file-upload"></i>
          <p>No hay archivos adjuntos</p>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeNotesModal()">
        Cancelar
      </button>
      <button class="btn-save" (click)="saveAppointmentNotes()" [disabled]="isSavingNotes">
        <i class="fas fa-save" *ngIf="!isSavingNotes"></i>
        <i class="fas fa-spinner fa-spin" *ngIf="isSavingNotes"></i>
        {{ isSavingNotes ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>
  </div>
</div>

<!-- Modal de Resultados del Círculo de la Vida -->
<div class="modal-overlay" *ngIf="showCircleLifeModal" (click)="closeCircleLifeModal()">
  <div class="circle-life-modal-content" (click)="$event.stopPropagation()">
    <div class="circle-life-modal-header">
      <h2 class="circle-life-modal-title">Resultados del Círculo de la Vida</h2>
      <button class="circle-life-modal-close" (click)="closeCircleLifeModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="circle-life-modal-body" *ngIf="!isLoading">
      <!-- Wheel of Life Section -->
      <div class="wheel-of-life-section">
        <!-- Info Bar -->
        <div class="info-bar">
          <div class="info-content">
            <i class="check-icon">✓</i>
            <span>En 30 días puedes volver a realizar el análisis de tu rueda de la vida.</span>
          </div>
        </div>

        <div class="wheel-container">
          <!-- Main Title -->
          <h1 class="wheel-title">RUEDA DE LA VIDA</h1>
          
          <!-- Main Description -->
          <div class="main-description">
            <p>
              <strong>{{user?.firstName || user?.name?.split(' ')[0]}}</strong>, este es el momento ideal para comenzar a construir tu siguiente etapa. 
              El tiempo avanza rápido, y cada decisión que tomes hoy puede multiplicarse en bienestar, propósito y seguridad para el futuro. 
              Has elegido <strong>{{priorityArea}}</strong> como tu eje, y eso marca el punto de partida para diseñar la vida que deseas vivir mañana. 
              Aquí tienes el resumen de tu Círculo de la Vida.
            </p>
          </div>
          
          <!-- Chart Section -->
          <div class="chart-section">
            <div class="radar-chart-wrapper">
              <app-radar-chart [data]="circleLifeSeriesApply" [showLegend]="false" [events]="circleLifeEventsSubject.asObservable()"></app-radar-chart>
              <div class="legend-container">
                <div 
                  *ngFor="let series of circleLifeSeries; let i = index"
                  class="legend-item"
                  [class.active]="circleLifeSeriesIndex === i"
                  (click)="changeCircleLifeSeriesToShow(i)"
                >
                  <span class="legend-dot" [style.background-color]="getCircleLifeSeriesColor(i)"></span>
                  <span class="legend-text">{{ series.name }}</span>
                </div>
                <!-- <div 
                  *ngIf="circleLifeSeriesIndexComparative >= 0"
                  class="legend-item"
                  [class.active]="circleLifeSeriesIndex === circleLifeSeriesIndexComparative"
                  (click)="changeCircleLifeSeriesToShow(circleLifeSeriesIndexComparative)"
                >
                  <span class="legend-dot" [style.background-color]="getCircleLifeSeriesColor(circleLifeSeriesIndexComparative)"></span>
                  <span class="legend-text">Comparativo</span>
                </div> -->
              </div>
            </div>
          </div>
          
          <!-- Bottom Description -->
          <div class="bottom-description">
            <p>
              Tus resultados también muestran que sería valioso trabajar en <strong>{{opportunityAreas}}</strong>, para lograr un desarrollo más equilibrado. 
              Recuerda que ya cuentas con fortalezas en <strong>{{strengthAreas}}</strong>, y esas bases te darán confianza y soporte en cada paso hacia el futuro que deseas. 
              A continuación, encontrarás el detalle de tu análisis en tu Círculo de la Vida.
            </p>
          </div>
        </div>
      </div>

      <!-- Analysis Details Section -->
      <div class="analysis-details-section">
        <div class="details-container">
          <h2 class="details-title">DETALLES DEL ANÁLISIS</h2>
          
          <!-- Gap Indicators -->
          <div class="gap-indicators">
            <div class="gap-indicator low-gap">
              <div class="gap-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="10" fill="#28a745"/>
                  <text x="12" y="16" text-anchor="middle" fill="white" font-size="14" font-weight="bold">?</text>
                </svg>
              </div>
              <div class="gap-info">
                <p class="gap-description">Fortaleza actual, mantener y reforzar y no descuidar.</p>
                <span class="gap-label">Brecha baja (1 a 3 puntos)</span>
              </div>
            </div>
            
            <div class="gap-indicator medium-gap">
              <div class="gap-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="10" fill="#fd7e14"/>
                  <text x="12" y="16" text-anchor="middle" fill="white" font-size="14" font-weight="bold">?</text>
                </svg>
              </div>
              <div class="gap-info">
                <p class="gap-description">Área con oportunidades importantes de mejora.</p>
                <span class="gap-label">Brecha media (4 a 6 puntos)</span>
              </div>
            </div>
            
            <div class="gap-indicator high-gap">
              <div class="gap-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="10" fill="#dc3545"/>
                  <text x="12" y="16" text-anchor="middle" fill="white" font-size="14" font-weight="bold">?</text>
                </svg>
              </div>
              <div class="gap-info">
                <p class="gap-description">Oportunidad crítica que requiere acción inmediata.</p>
                <span class="gap-label">Brecha alta (7 a 9 puntos)</span>
              </div>
            </div>
          </div>

          <!-- Mobile Gap Indicators -->
          <div class="gap-indicators-mobile">
            <div class="gap-indicator-mobile low-gap-mobile">
              <div class="gap-checkmark">✓</div>
              <span class="gap-text-mobile">Brecha baja (0 a 3 puntos)</span>
            </div>

            <div class="gap-indicator-mobile medium-gap-mobile">
              <div class="gap-checkmark">✓</div>
              <span class="gap-text-mobile">Brecha media (4 a 6 puntos)</span>
            </div>

            <div class="gap-indicator-mobile high-gap-mobile">
              <div class="gap-checkmark">✓</div>
              <span class="gap-text-mobile">Brecha alta (7 a 9 puntos)</span>
            </div>
          </div>
          
          <div class="details-table">
            <div class="table-header">
              <div class="header-cell">Área</div>
              <div class="header-cell">Análisis presente</div>
              <div class="header-cell">Análisis futuro</div>
              <div class="header-cell">Brecha por cerrar</div>
            </div>
            
            <div class="table-body">
              <div class="table-row" *ngFor="let area of circleLifeAnalysisAreas">
                <div class="data-cell area-cell">{{ area.name }}</div>
                <div class="data-cell present-cell">{{ area.present }}</div>
                <div class="data-cell future-cell">{{ area.future }}</div>
                <div class="data-cell gap-cell">
                  <span class="gap-pill" [ngClass]="getGapClass(area.gap)">{{ area.gap }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Life Areas Section -->
      <div class="life-areas-section">
        <div class="areas-container">
          <h2 class="areas-title">AREAS DE LA VIDA</h2>
          <p class="areas-description">
            Este es tu resumen por área de vida: organizado de la mayor a la menor brecha, con consejos prácticos para que empieces a accionar y construir tu plan de vida desde hoy.
          </p>
          
          <div class="areas-list">
            <div class="area-item" *ngFor="let area of circleLifeAreas; let i = index" (click)="toggleCircleLifeArea(i)">
              <div class="area-content">
                <div class="area-icon">
                  <img [src]="area.icon" [alt]="area.name" class="area-icon-img">
                </div>
                <div class="area-text">
                  <span class="area-name">{{ area.name }}</span>
                </div>
                <div class="area-chevron">
                  <i class="fas fa-chevron-right" [class.rotated]="area.expanded"></i>
                </div>
              </div>
              <div class="area-details" *ngIf="area.expanded" [ngClass]="area.gapClass2">
                <p>{{ area.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="circle-life-modal-body loading" *ngIf="isLoading">
      <div style="text-align: center; padding: 40px;">
        <i class="fas fa-spinner fa-spin" style="font-size: 48px; color: #CE0024;"></i>
        <p style="margin-top: 20px;">Cargando resultados...</p>
      </div>
    </div>

    <div class="circle-life-modal-footer">
      <button class="btn-close-modal" (click)="closeCircleLifeModal()">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Análisis Profundo -->
<div class="modal-overlay" *ngIf="showAnalisisProfundoModal" (click)="closeAnalisisProfundoModal()">
  <div class="analisis-profundo-modal-content" (click)="$event.stopPropagation()">
    <div class="analisis-profundo-modal-header">
      <h2 class="analisis-profundo-modal-title">Análisis Profundo</h2>
      <button class="analisis-profundo-modal-close" (click)="closeAnalisisProfundoModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="analisis-profundo-modal-body" *ngIf="!analisisProfundoLoading">
      <!-- Tests List -->
      <div class="tests-list">
        <div class="test-item" *ngFor="let test of analisisProfundoTests; let i = index" [ngClass]="{'completed': test.progress === 100}">
          <div class="test-content">
            <div class="test-title">
              <span class="test-number">{{getAnalisisProfundoTestNumber(test, i)}}</span>
              <span class="test-name">{{test.dimensions?.[0]?.area?.name || 'Área no disponible'}}</span>
            </div>
            <div class="test-progress-section">
              <div class="progress-bar">
                <div class="progress-fill" [ngClass]="{'completed': test.progress === 100}" [style.width.%]="test.progress"></div>
              </div>
              <span class="progress-percentage">{{ test.progress }}%</span>
            </div>
          </div>
          
          <!-- Matrices de resultados individuales para cada dimensión (solo si está completado) -->
          <div *ngIf="test.progress === 100 && test.dimensions" class="dimension-matrices">
            <div class="matrix-content">
              <div *ngFor="let dimension of test.dimensions" class="subdimension-matrix">
                <h4 class="subdimension-title">{{dimension.name}}</h4>
                <div class="matrix-table-container">
                  <table class="matrix-table">
                    <thead>
                      <tr>
                        <th>Área</th>
                        <th>Análisis Presente</th>
                        <th>Análisis Futuro</th>
                        <th>Brecha por Cerrar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let question of dimension.questions; let j = index">
                        <td class="area-name">{{j + 1}}. {{question.name}}</td>
                        <td class="analysis-value">{{question.answer?.valueNow || 0}}</td>
                        <td class="analysis-value">{{question.answer?.valueFuture || 0}}</td>
                        <td class="gap-value" [ngClass]="getAnalisisProfundoGapClass(calculateAnalisisProfundoGap(question))">
                          {{calculateAnalisisProfundoGap(question)}}
                        </td>
                      </tr>
                      <tr class="average-row">
                        <td class="area-name"><strong>Promedio</strong></td>
                        <td class="analysis-value"><strong>{{getAnalisisProfundoAveragePresent(dimension.questions)}}</strong></td>
                        <td class="analysis-value"><strong>{{getAnalisisProfundoAverageFuture(dimension.questions)}}</strong></td>
                        <td class="gap-value"><strong>{{getAnalisisProfundoAverageGap(dimension.questions)}}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="analisisProfundoTests.length === 0" class="no-tests-message">
        <p>No hay tests de análisis profundo disponibles</p>
      </div>
    </div>

    <div class="analisis-profundo-modal-body loading" *ngIf="analisisProfundoLoading">
      <div style="text-align: center; padding: 40px;">
        <i class="fas fa-spinner fa-spin" style="font-size: 48px; color: #CE0024;"></i>
        <p style="margin-top: 20px;">Cargando resultados...</p>
      </div>
    </div>

    <div class="analisis-profundo-modal-footer">
      <button class="btn-close-modal" (click)="closeAnalisisProfundoModal()">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Mapa de Identidad (PRD) -->
<div class="modal-overlay" *ngIf="showIdentityMapModal" (click)="closeIdentityMapModal()">
  <div class="identity-map-modal-content" (click)="$event.stopPropagation()">
    <div class="identity-map-modal-header">
      <h2 class="identity-map-modal-title">Resultado Análisis profundo </h2>
      <button class="identity-map-modal-close" (click)="closeIdentityMapModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="identity-map-modal-body" *ngIf="!identityMapPRDLoading">

      <!-- Guía de Reflexión Personal -->
      <div *ngIf="shouldShowIdentityMapReflectionGuide()" class="identity-map-reflection-guide-section">
        <div class="identity-map-reflection-guide-header" (click)="toggleIdentityMapReflectionGuide()">
          <span class="identity-map-reflection-guide-title">Guía de reflexión personal</span>
          <i class="fas" [ngClass]="identityMapReflectionGuideExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
        
        <!-- Contenido de la guía de reflexión -->
        <div *ngIf="identityMapReflectionGuideExpanded" class="identity-map-reflection-guide-content">
          <!-- Mensaje de finalización (si ya fue completada) -->
          <div *ngIf="identityMapReflectionGuideCompleted" class="identity-map-reflection-completion">
            <h3>¡Felicitaciones!</h3>
            <p>Por darte este tiempo para mirar hacia adentro y comenzar a diseñar la vida que deseas construir!</p>
            <p *ngIf="identityMapReflectionCompletedAt" class="completion-date">Completado el: {{ identityMapReflectionCompletedAt | date:'medium' }}</p>
          </div>

          <!-- Todas las secciones y respuestas -->
          <div *ngFor="let section of identityMapReflectionSections" class="identity-map-reflection-section">
            <h4 class="identity-map-reflection-section-title">{{ section.title }}</h4>
            <div class="identity-map-reflection-questions">
              <div *ngFor="let question of section.questions; let i = index" class="identity-map-reflection-question-block">
                <div class="identity-map-reflection-question-number">{{ i + 1 }}</div>
                <div class="identity-map-reflection-question-content">
                  <p class="identity-map-reflection-question-text">{{ question.text }}</p>
                  
                  <!-- Respuesta de texto -->
                  <div *ngIf="question.type === 'text' || question.type === 'single-text'" class="identity-map-reflection-answer-text">
                    <div class="identity-map-reflection-answer-value">
                      {{ getIdentityMapReflectionAnswer(question.id)?.answer || 'Sin respuesta' }}
                    </div>
                  </div>

                  <!-- Respuesta de pares de dimensión -->
                  <div *ngIf="question.type === 'dimension-pair'" class="identity-map-reflection-dimension-pairs">
                    <div *ngFor="let pair of getIdentityMapReflectionDimensionPairs(question.id); let pairIndex = index" class="identity-map-reflection-dimension-pair">
                      <div class="identity-map-reflection-dimension-item">
                        <strong>Dimensión:</strong> {{ pair.dimension || 'Sin especificar' }}
                      </div>
                      <div class="identity-map-reflection-dimension-item">
                        <strong>Subdimensión:</strong> {{ pair.subdimension || 'Sin especificar' }}
                      </div>
                    </div>
                    <div *ngIf="getIdentityMapReflectionDimensionPairs(question.id).length === 0" class="identity-map-reflection-no-answer">
                      Sin respuesta
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensaje si no hay respuestas -->
          <div *ngIf="!identityMapReflectionGuideCompleted && identityMapReflectionAnswers.length === 0" class="identity-map-reflection-no-answers">
            <p>La guía de reflexión personal aún no ha sido completada.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="identity-map-modal-body loading" *ngIf="identityMapPRDLoading">
      <div style="text-align: center; padding: 40px;">
        <i class="fas fa-spinner fa-spin" style="font-size: 48px; color: #CE0024;"></i>
        <p style="margin-top: 20px;">Cargando resultados...</p>
      </div>
    </div>

    <div class="identity-map-modal-footer">
      <button class="btn-close-modal" (click)="closeIdentityMapModal()">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Mapa de Identidad (Identity Map) -->
<div class="modal-overlay" *ngIf="showIdentityMapDetailsModal" (click)="closeIdentityMapDetailsModal()">
  <div class="identity-map-details-modal-content" (click)="$event.stopPropagation()">
    <div class="identity-map-details-modal-header">
      <h2 class="identity-map-details-modal-title">Mapa de Identidad</h2>
      <button class="identity-map-details-modal-close" (click)="closeIdentityMapDetailsModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="identity-map-details-modal-body" *ngIf="!identityMapLoading && identityMapData">
      <!-- Sección Línea de vida -->
      <div class="identity-map-details-section">
        <h3 class="identity-map-details-section-title">Línea de vida</h3>
        <div class="identity-map-details-lifeline">
          <div class="lifeline-peaks" *ngIf="identityMapData.lifeLine?.peaks?.length > 0">
            <h4>Picos - Logros, cambios positivos, hitos personales</h4>
            <ul>
              <li *ngFor="let peak of identityMapData.lifeLine.peaks">{{ peak.text }}</li>
            </ul>
          </div>
          <div class="lifeline-valleys" *ngIf="identityMapData.lifeLine?.valleys?.length > 0">
            <h4>Valles - Retos, fracasos, aprendizajes clave</h4>
            <ul>
              <li *ngFor="let valley of identityMapData.lifeLine.valleys">{{ valley.text }}</li>
            </ul>
          </div>
          <div *ngIf="identityMapData.lifeLine?.peaks?.length === 0 && identityMapData.lifeLine?.valleys?.length === 0" class="no-data-message">
            <p>No hay datos de línea de vida registrados</p>
          </div>
        </div>
      </div>

      <!-- Sección Mi pasado -->
      <div class="identity-map-details-section" *ngIf="identityMapData.past">
        <h3 class="identity-map-details-section-title">Mi pasado</h3>
        <div class="identity-map-details-past">
          <div class="past-questions-items">
            <div *ngFor="let question of identityMapData.past.questions; let i = index" class="past-question-item">
              <div class="question-icon">📝</div>
              <div class="question-content">
                <strong>{{ i + 1 }}. {{ question.text }}</strong>
                <p>{{ question.answer || 'Sin respuesta' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección Mi presente -->
      <div class="identity-map-details-section" *ngIf="identityMapData.present">
        <h3 class="identity-map-details-section-title">Mi presente</h3>
        
        <!-- Matriz 2x2 -->
        <div class="identity-map-details-matrix">
          <h4>Matriz de Energía</h4>
          <div class="matrix-results-grid">
            <div class="quadrant-result fortaleza">
              <div class="quadrant-header">
                <div class="quadrant-icon">💪</div>
                <h5>Fortaleza</h5>
                <span class="quadrant-subtitle">(Hago bien + Me energiza)</span>
              </div>
              <ul>
                <li *ngFor="let item of identityMapData.present.presentQuadrants[0]?.items">
                  <span *ngIf="item && item.trim()">{{ item }}</span>
                </li>
                <li *ngIf="isQuadrantEmpty(0)" class="no-item">Sin datos</li>
              </ul>
            </div>
            
            <div class="quadrant-result riesgo">
              <div class="quadrant-header">
                <div class="quadrant-icon">⚠️</div>
                <h5>Riesgo</h5>
                <span class="quadrant-subtitle">(Hago bien + Me drena)</span>
              </div>
              <ul>
                <li *ngFor="let item of identityMapData.present.presentQuadrants[1]?.items">
                  <span *ngIf="item && item.trim()">{{ item }}</span>
                </li>
                <li *ngIf="isQuadrantEmpty(1)" class="no-item">Sin datos</li>
              </ul>
            </div>
            
            <div class="quadrant-result aprendizaje">
              <div class="quadrant-header">
                <div class="quadrant-icon">📚</div>
                <h5>Aprendizaje</h5>
                <span class="quadrant-subtitle">(Hago mal + Me energiza)</span>
              </div>
              <ul>
                <li *ngFor="let item of identityMapData.present.presentQuadrants[2]?.items">
                  <span *ngIf="item && item.trim()">{{ item }}</span>
                </li>
                <li *ngIf="isQuadrantEmpty(2)" class="no-item">Sin datos</li>
              </ul>
            </div>
            
            <div class="quadrant-result evitar">
              <div class="quadrant-header">
                <div class="quadrant-icon">🚫</div>
                <h5>Evitar</h5>
                <span class="quadrant-subtitle">(Hago mal + Me drena)</span>
              </div>
              <ul>
                <li *ngFor="let item of identityMapData.present.presentQuadrants[3]?.items">
                  <span *ngIf="item && item.trim()">{{ item }}</span>
                </li>
                <li *ngIf="isQuadrantEmpty(3)" class="no-item">Sin datos</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Reflexiones -->
        <div class="identity-map-details-reflections">
          <h4>Reflexiones</h4>
          <div class="reflection-items">
            <div class="reflection-item stop-doing">
              <div class="reflection-icon">🛑</div>
              <div class="reflection-content">
                <strong>Stop-doing</strong>
                <p>{{ identityMapData.present.stopDoing || 'Sin respuesta' }}</p>
              </div>
            </div>
            <div class="reflection-item double-down">
              <div class="reflection-icon">🎯</div>
              <div class="reflection-content">
                <strong>Doblar la apuesta</strong>
                <p>{{ identityMapData.present.doubleDown || 'Sin respuesta' }}</p>
              </div>
            </div>
            <div class="reflection-item objectives" *ngIf="identityMapData.present.objectives">
              <div class="reflection-icon">🏆</div>
              <div class="reflection-content">
                <strong>Objetivos</strong>
                <p>{{ identityMapData.present.objectives || 'Sin respuesta' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="identity-map-details-modal-body loading" *ngIf="identityMapLoading">
      <div style="text-align: center; padding: 40px;">
        <i class="fas fa-spinner fa-spin" style="font-size: 48px; color: #CE0024;"></i>
        <p style="margin-top: 20px;">Cargando resultados...</p>
      </div>
    </div>

    <div class="identity-map-details-modal-footer">
      <button class="btn-close-modal" (click)="closeIdentityMapDetailsModal()">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Visionboard -->
<div class="modal-overlay" *ngIf="showVisionboardModal" (click)="closeVisionboardModal()">
  <div class="visionboard-modal-content" (click)="$event.stopPropagation()">
    <div class="visionboard-modal-header">
      <h2 class="visionboard-modal-title">Visionboard</h2>
      <button class="visionboard-modal-close" (click)="closeVisionboardModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="visionboard-modal-body" *ngIf="!visionboardLoading">
      <!-- Título del Visionboard -->
      <div class="visionboard-title-section" *ngIf="visionboardTitle">
        <h3>{{ visionboardTitle }}</h3>
      </div>

      <!-- Vision Board Grid -->
      <div class="visionboard-display" *ngIf="userVisionboards.length > 0">
        <div class="vb-masonry-grid">
          <!-- Canvas para pizarra interactiva (solo lectura) -->
          <canvas #visionboardWhiteboardCanvas 
                  class="vb-whiteboard-canvas"
                  style="pointer-events: none;">
          </canvas>
          <!-- Columna 1 -->
          <div class="vb-column vb-column-1">
            <div class="vb-grid-item vb-item-tall" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[0]?.imageId || userVisionboards[0]?.images?.[0]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[0]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[0]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[0]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[0]?.text && !userVisionboards[0]?.images?.[0]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[0]?.text }}</p>
              </div>
            </div>
            <div class="vb-grid-item vb-item-medium" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[1]?.imageId || userVisionboards[0]?.images?.[1]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[1]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[1]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[1]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[1]?.text && !userVisionboards[0]?.images?.[1]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[1]?.text }}</p>
              </div>
            </div>
            <div class="vb-grid-item vb-item-large" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[2]?.imageId || userVisionboards[0]?.images?.[2]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[2]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[2]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[2]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[2]?.text && !userVisionboards[0]?.images?.[2]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[2]?.text }}</p>
              </div>
            </div>
          </div>

          <!-- Columna 2 -->
          <div class="vb-column vb-column-2">
            <div class="vb-grid-item vb-item-medium" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[3]?.imageId || userVisionboards[0]?.images?.[3]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[3]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[3]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[3]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[3]?.text && !userVisionboards[0]?.images?.[3]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[3]?.text }}</p>
              </div>
            </div>
            <div class="vb-grid-item vb-item-tall" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[4]?.imageId || userVisionboards[0]?.images?.[4]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[4]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[4]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[4]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[4]?.text && !userVisionboards[0]?.images?.[4]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[4]?.text }}</p>
              </div>
            </div>
          </div>

          <!-- Columna 3 -->
          <div class="vb-column vb-column-3">
            <div class="vb-grid-item vb-item-short" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[5]?.imageId || userVisionboards[0]?.images?.[5]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[5]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[5]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[5]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[5]?.text && !userVisionboards[0]?.images?.[5]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[5]?.text }}</p>
              </div>
            </div>
            <div class="vb-grid-item vb-item-medium-tall" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[6]?.imageId || userVisionboards[0]?.images?.[6]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[6]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[6]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[6]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[6]?.text && !userVisionboards[0]?.images?.[6]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[6]?.text }}</p>
              </div>
            </div>
            <div class="vb-grid-item vb-item-medium" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[7]?.imageId || userVisionboards[0]?.images?.[7]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[7]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[7]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[7]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[7]?.text && !userVisionboards[0]?.images?.[7]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[7]?.text }}</p>
              </div>
            </div>
          </div>

          <!-- Columna 4 -->
          <div class="vb-column vb-column-4">
            <div class="vb-grid-item vb-item-medium" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[8]?.imageId || userVisionboards[0]?.images?.[8]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[8]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[8]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[8]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[8]?.text && !userVisionboards[0]?.images?.[8]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[8]?.text }}</p>
              </div>
            </div>
            <div class="vb-grid-item vb-item-extra-tall" 
                 [ngClass]="{'vb-has-content': userVisionboards[0]?.images?.[9]?.imageId || userVisionboards[0]?.images?.[9]?.text}">
              <img *ngIf="userVisionboards[0]?.images?.[9]?.imageId && getVisionboardPreview(userVisionboards[0]?.images?.[9]?.imageId)" 
                   [src]="getVisionboardPreview(userVisionboards[0]?.images?.[9]?.imageId)" 
                   alt="Imagen" class="vb-image">
              <div *ngIf="userVisionboards[0]?.images?.[9]?.text && !userVisionboards[0]?.images?.[9]?.imageId" 
                   class="vb-text-content">
                <p class="vb-text">{{ userVisionboards[0]?.images?.[9]?.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mensaje si no hay visionboards -->
      <div class="no-visionboard-message" *ngIf="userVisionboards.length === 0">
        <p>El usuario aún no ha creado ningún visionboard.</p>
      </div>

      <!-- Sección de Reflexiones sobre Visionboard -->
      <div class="visionboard-reflection-section" *ngIf="visionboardReflectionCompleted && visionboardReflectionQuestions.length > 0">
        <div class="visionboard-reflection-header">
          <h3>Tareas desbloqueadas</h3>
          <p class="visionboard-reflection-subtitle">Reflexiones sobre el Vision Board</p>
        </div>
        <div class="visionboard-reflection-questions">
          <div *ngFor="let question of visionboardReflectionQuestions; let i = index" class="visionboard-reflection-question-item">
            <div class="question-icon">📝</div>
            <div class="question-content">
              <strong>{{ i + 1 }}. {{ question }}</strong>
              <p>{{ visionboardReflectionAnswers[i] || 'Sin respuesta' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="visionboardLoading" class="visionboard-loading">
      <div style="text-align: center; padding: 40px;">
        <i class="fas fa-spinner fa-spin" style="font-size: 48px; color: #CE0024;"></i>
        <p style="margin-top: 20px;">Cargando visionboard...</p>
      </div>
    </div>

    <div class="visionboard-modal-footer">
      <button class="btn-close-modal" (click)="closeVisionboardModal()">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal PRD (Revisión) -->
<div class="modal-overlay" *ngIf="showPRDModal" (click)="closePRDModal()">
  <div class="prd-modal-content" (click)="$event.stopPropagation()">
    <div class="prd-modal-header">
      <h2 class="prd-modal-title">Revisión</h2>
      <button class="prd-modal-close" (click)="closePRDModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="prd-modal-body">
      <!-- Page Header -->
      <div class="prd-page-header">
        <h1 class="prd-page-title">Revisión</h1>
        <p class="prd-page-description">Tu plan de vida se construirá a partir de estas prioridades. Empieza por lo más importante para ti hoy.</p>
      </div>

      <!-- Completion Message -->
      <div class="prd-completion-message" *ngIf="prdRankingCompleted">
        <div class="prd-completion-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <div class="prd-completion-text">
          <h3>¡Ranking Completado!</h3>
          <p>Has finalizado exitosamente el ranking de todas las áreas. Tus prioridades han sido guardadas.</p>
        </div>
      </div>

      <!-- High Priority Table -->
      <div class="prd-high-priority-section" *ngIf="prdHighPriorityQuestions.length > 0">
        <div class="prd-section-title-container">
          <h2 class="prd-section-title">Prioridad ALTA</h2>
        </div>

        <div class="prd-high-priority-table-container">
          <table class="prd-high-priority-table">
            <thead>
              <tr>
                <th class="prd-col-area">Área</th>
                <th class="prd-col-gap">Brecha por cerrar</th>
                <th class="prd-col-priority">Prioridad</th>
                <th class="prd-col-ranking">Ranking</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of prdHighPriorityQuestions" class="prd-table-row">
                <td class="prd-col-area">
                  <span class="prd-area-text">{{ item.question.name }}</span>
                </td>
                <td class="prd-col-gap">
                  <div class="prd-gap-badge" [ngClass]="{
                    'gap-low': item.gap <= 3,
                    'gap-medium': item.gap > 3 && item.gap <= 6,
                    'gap-high': item.gap > 6
                  }">
                    {{ item.gap }}
                  </div>
                </td>
                <td class="prd-col-priority">
                  <div class="prd-priority-badge">
                    Alta
                  </div>
                </td>
                <td class="prd-col-ranking">
                  <div class="prd-ranking-value">
                    {{ getPRDQuestionRanking(item.question) || '-' }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- No High Priority Message -->
      <div class="prd-no-high-priority" *ngIf="prdHighPriorityQuestions.length === 0 && prdTests.length > 0 && !prdLoading">
        <div class="prd-empty-state">
          <i class="fas fa-info-circle"></i>
          <p>No hay prioridades marcadas como "Alta" aún.</p>
          <p class="prd-sub-text">Dirígete al módulo de Ranking para clasificar tus áreas.</p>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="prdLoading" class="prd-loading">
        <div style="text-align: center; padding: 40px;">
          <i class="fas fa-spinner fa-spin" style="font-size: 48px; color: #CE0024;"></i>
          <p style="margin-top: 20px;">Cargando datos de revisión...</p>
        </div>
      </div>
    </div>

    <div class="prd-modal-footer">
      <button class="btn-close-modal" (click)="closePRDModal()">
        Cerrar
      </button>
    </div>
  </div>
</div>